<template>
  <div>
    <!-- <headerList></headerList> -->
    <special-header pagetype="index"></special-header>

    <!-- banner部分 -->
    <!-- <div class="video-banner relative">
  
      <div class="video-search-box flex absolute">
        <div class="video-filter bg-ff f-16 c-11 flex-c">
          <span class="mr-10">{{ name }}</span>
        </div>
        <div class="flex-box bg-ff flex plr-20">
          <input type="text" v-model="search" class="flex-box f-18 c-33" placeholder="请输入关键词, 搜索精选视频"
            @keyup.enter="bindvideoList">
          <span class="iconfont iconsearch ml-40 c-11 f-22" @click="bindvideoList"></span>
        </div>
      </div>
      <video src="../assets/video_banner.mp4" width="100%" autoplay="autoplay" mediatype="video" loop="loop"
        ref="video_banner" class="absolute"></video>
    </div> -->

    <!-- 主体内容 -->
    <div class="video_box">
      <div>
        <!-- 关键词 -->
        <div class="pt-30 flex">
          <!-- 面包屑 -->
          <div class="flex video_title_m f-14 c-33">
            <span class="iconfont icontubiao-dingwei"></span>
            <span>合肥市文化和旅游局</span>
            <span class="iconfont iconxiangyoujiantou"></span>
            <span>视频</span>

          </div>
          <!-- <div class="ml-30 mr-30 c-c2 video-line-s"></div>
          <div class="flex-box f-14 c-99">
            <span>相关搜索: </span>
            <span style="cursor: pointer;" class="mr-10" v-for="item in search_key"
              @click="enterSearch('SYS_TOPIC_cn', item)" :key="item">{{ item }}</span>
          </div> -->
        </div>



        <!-- 视频资源列表 -->
        <div class="video-list-box flex flex-x-s pb-30">
          <div class="video-detail mt-25 mr-15 shou" v-for="item, index in video_arr" :key="index"
            @click="toImgdetail(item.docId, item.doclibId)">
            <div class="media-box">
              <img :src="item.middlePath" alt="" />
            </div>
            <div class="text bg-ff plr-15 flex">
              <div class="flex f-16">
                <p class="onelist" style="max-width: 200px;">{{ item.docName }}</p>
                <!-- <p> - 01:37</p> -->
              </div>
              <!-- <div class="design f-14 c-ff">4k</div> -->
            </div>
          </div>
        </div>

        <!-- 分页 -->
        <div class="pt-25 pb-30 flex-c">
          <Page :total="total" :page-size="9" @on-change="changePage" />
          <!-- 	<div class="toPage bg-ff flex ml-20">
						<div class="flex f-14">
							<span>到第</span>
							<input type="text" v-model="page" />
							<span>页</span>
						</div>
						<div class="pagebtn f-14 ml-20">确定</div>
					</div> -->
        </div>

      </div>
    </div>



    <footer-view></footer-view>
  </div>
</template>

<script>
import specialHeader from './specialHeader.vue';
import headerList from './speciaHheader_nav.vue';
import headerView from './header.vue'
import footerView from './footer.vue'
export default {
  data() {
    return {
      nav_list: [],
      video_list: [],
      search_key: [],
      video_cate: [],
      cats: 0,
      totalPages: 0,
      total: 0,
      name: '',
      search: '',
      video_arr: []
    }
  },

  components: {
    headerView,
    footerView,
    headerList,
    specialHeader,
  },

  created() {
    let _this = this

    _this.cats = _this.$route.query.cats
    _this.name = _this.$route.query.name
    document.title = this.$route.query.name

    // this.bindNavlist()

    // this.bindMusiccate() // 视频分类
    // this.bindvideoList() //　视频列表
    this.bindSearch()
  },

  mounted() {
    this.getindexVideo()
    // console.log('this.$refs.video_banner')
    // this.$refs.video_banner.play()
  },

  methods: {
    // 获取视频 注意先取视频栏目下面的资源
    async getindexVideo(page = 0) {
      // console.log(11212121);
      let _this = this;
      const res = await _this.get_res('/topic/res/page', { sld: 'AHSCXB', topicId: 72, page: page, size: 9 });

      res.content.forEach(async x => {
        x.isShow = true;
        const res_1 = await _this.get_video(x.docId);
        x.attId = res_1[0];
        x.suijinum = _this.randomNum(0, 1000);
      });
      _this.video_arr = res.content;
      _this.totalPages = res.totalPages
      _this.total = res.totalElements

    },
    randomNum(minNum, maxNum) {
      switch (arguments.length) {
        case 1:
          return parseInt(Math.random() * minNum + 1, 10);
          break;
        case 2:
          return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10);
          break;
        default:
          return 0;
          break;
      }
    },

    // 获取关键字
    async bindSearch() {
      let _this = this
      const res = await _this.get_res('/search/getHotWords', { size: 5, sld: "AHSCXB" })
      if (res.length) {
        _this.search_key = res
      }
    },

    // 跳转到图片详情
    toImgdetail(id, tid) {
      // this.$router.push({path: '/video_detail', query: {id,tid}})

      let link = this.$router.resolve({
        path: '/video_detail',
        query: { id, tid }
      });
      window.open(link.href, "_blank"); //打开新窗口
    },

    // 显示与否-子导航
    navMouse(index, state) {
      let _this = this
      let obj = _this.nav_list[index]
      obj.isShow = state
      _this.nav_list.splice(index, 1, obj)
    },

    // 控制音频播放与否
    musicEndorBegin(index, state) {
      let id = 'audio' + index
      let _this = this
      let audio = document.getElementById(id)
      if (audio !== null) {
        if (state) {
          audio.pause()
        } else {
          audio.play()
        }
        let obj = _this.music_list[index]
        obj.isPlay = !state
        _this.music_list.splice(index, 1, obj)
      }
    },

    // 获取播放时间 
    timeupdate(e) {
      // console.log(e.target.currentTime)
    },

    getDuration(index) {
      let audio = 'audio' + index
      let au = this.$refs[audio]
      console.log(this.$refs[audio][0].duration); //此时可以获取到duration
      // this.duration = this.$refs.audio.duration;
    },

    // 跳转
    bindlinkTo(path, name) {
      if (path == '') {
        return
      }
      this.$router.push({ path, query: { name } })
    },

    // 获取音频列表
    async bindvideoList(page = 0) {
      let _this = this
      _this.$Spin.show()
      let data = {}
      if (_this.search != '') {
        data.field = "SYS_TOPIC_cn"
        data.q = _this.search
      }
      data.cats = _this.cats
      data.size = 21
      data.page = page
      data.t = 29
      data.sld = "AHSCXB"
      data.sort = "SYS_LASTMODIFIED_dt,desc"
      const res = await _this.get_res('/search', data)
      _this.video_list = res.content
      _this.totalPages = res.totalPages
      _this.total = res.totalElements
      _this.$Spin.hide()
    },

    // 获取音频的分类
    async bindMusiccate() {
      let _this = this
      const res = await _this.get_res('/cats?sld=AHSCXB&docLibId=29&parentId=6242-29', {})
      res.forEach(x => {
        let index_2 = x.text.lastIndexOf("'")
        let index_1 = x.text.indexOf("'")
        x.title = x.text.substring(index_1 + 1, index_2)
      })
      _this.video_cate = res
    },

    changePage(page) {
      this.getindexVideo(page - 1)
    },

  },

  // 监听器监听路由的变化
  watch: {
    '$route'(to, from) {
      let _this = this
      _this.search = ''
      _this.cats = _this.$route.query.cats
      _this.name = _this.$route.query.name
      // 做一些路由变化的响应
      // this.bindvideoList(0)

    }
  },



  beforeDestroy() {
    document.title = '图片安徽'
  },
}
</script>

<style lang="less">
.nav-navigation {
  min-width: 1540px;
  margin: 0 auto;
  height: 85px;
  padding: 0 105px 0 230px;
}

.nav-list {
  cursor: pointer;
}

.nav-logo {
  width: 245px;
  height: 50px;
}

.nav-login {
  border: 1px solid #e5e5e5;
  padding: 2px 8px 3px;
  border-radius: 4px;
}

div.fixed {
  top: 0;
  z-index: 1000;
  width: 100%;
}

// 新优化规则 子导航
.nav-z-list {
  left: 50%;
  transform: translateX(-50%);
  top: 24px;
  padding: 0 15px 10px;
  border-radius: 3px;
  text-align: center;
  min-width: 90px;
  transition: all .5s;
  overflow: hidden;
  opacity: 0;
  height: 0;
}

.nav-z-list.isShow {
  opacity: 1;
  height: auto;
}

.nav-z-list>div {
  white-space: nowrap;
  margin-top: 10px;
}

// 视频banner
.video-banner {
  height: 800px;

  video {
    top: 0;
    width: 100%;
    height: 100%;
    object-fit: fill
  }
}

// 搜索框
.video-search-box {
  left: 50%;
  z-index: 100;
  transform: translateX(-50%);
  top: 30%;
  width: 540px;
  border-radius: 4px;
  overflow: hidden;

  .video-filter {
    width: 95px;
    height: 50px;
  }

  .flex-box {
    opacity: .85;
    height: 50px;
  }
}

// 主体内容盒子
.video_box {
  background-color: #f3f4f8;

  >div {
    width: 1320px;
    margin: 0 auto;
  }
}

.video_title_m {
  >span {
    margin-right: 8px;
  }

  .iconxiangyoujiantou {
    font-size: 14px;
  }
}

.filter-btn {
  padding: 0 10px;
  height: 26px;
  line-height: 26px;
  border-radius: 13px;
  margin-right: 10px;
  cursor: pointer;
  transition: all .2s;
}

.filter-btn:hover,
.filter-btn.active {
  color: #fff;
  background-color: #33CFFF;
}

.filter-box {
  height: 50px;

  .ivu-checkbox-wrapper {
    margin-right: 6px !important;
  }
}

.video-list-box {
  .video-detail {
    width: 430px;
    border-radius: 4px;
    overflow: hidden;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.20);

    .media-box {
      width: 430px;
      height: 240px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .text {
      height: 60px;
    }

    .design {
      height: 26px;
      line-height: 26px;
      border-radius: 13px;
      background-color: #33CFFF;
      padding: 0 16px;
    }
  }

  .video-detail:nth-child(3n) {
    margin-right: 0;
  }
}


// 竖线
.video-line-s {
  width: 1px;
  height: 16px;
  background-color: #ddd;
}

.iconxiangxiajiantou {
  font-size: 12px;
}

// 初始化分页器的样式
// .ivu-page li {
//   border-radius: 50%;
//   width: 36px;
//   height: 36px;
//   line-height: 36px;
// }

// .ivu-page-item {
//   width: 36px;
//   height: 36px;
//   line-height: 36px;
// }

// .ivu-page-item-active {
//   background-image: linear-gradient(270deg, #34EAFF 0%, #328AFF 100%);
// }

// .ivu-page-item-active a {
//   color: #fff !important;
// }

// .toPage {
//   height: 36px;
//   border-radius: 18px;
//   padding: 0 15px;

//   input {
//     max-width: 40px;
//     margin: 0 7px;
//     border-bottom: 1px solid #333;
//   }

//   .pagebtn {
//     color: #33CFFF;
//   }
// }</style>
